import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {XMarkdown, Button} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', [
            _$cc(Button, {
                'type': 'primary',
                'ev-click': this.start.bind(this),
                'children': '开始流式输出'
            }),
            _$cc(Button, {
                'ev-click': this.reset.bind(this),
                'children': '重置'
            })
        ], 4, 'xmarkdown-demo-streaming-rich-actions'),
        _$ce(2, 'div', [
            _$ce(2, 'div', [
                _$ce(2, 'div', '标准宽度', 16, 'xmarkdown-demo-streaming-rich-title'),
                _$cc(XMarkdown, {
                    'content': this.get('content'),
                    'typing': {interval: 24, step: 5},
                    'streaming': this.get('streaming'),
                    'loading': this.get('loading')
                })
            ], 4, 'xmarkdown-demo-streaming-rich-panel'),
            _$ce(2, 'div', [
                _$ce(2, 'div', '窄容器', 16, 'xmarkdown-demo-streaming-rich-title'),
                _$cc(XMarkdown, {
                    'content': this.get('content'),
                    'typing': {interval: 24, step: 5},
                    'streaming': this.get('streaming'),
                    'loading': this.get('loading')
                })
            ], 4, 'xmarkdown-demo-streaming-rich-panel xmarkdown-demo-streaming-rich-panel-narrow')
        ], 4, 'xmarkdown-demo-streaming-rich-layout')
    ], 4, 'xmarkdown-demo-streaming-rich');
};